import React from "react";
import { Package } from "lucide-react";

interface Collection {
  id: string;
  title: string;
  image?: string;
}

interface CollectionCardProps {
  collection: Collection;
  isSelected: boolean;
  onToggle: () => void;
}

const CollectionCard: React.FC<CollectionCardProps> = ({
  collection,
  isSelected,
  onToggle,
}) => {
  return (
    <div
      onClick={onToggle}
      className="flex items-center gap-3 px-4 py-3 border-b border-border last:border-b-0 hover:bg-muted/30 cursor-pointer transition-colors"
    >
      {/* Checkbox */}
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => {}}
        className="w-4 h-4 rounded border-border cursor-pointer shrink-0"
        style={{
          accentColor: isSelected ? 'var(--primary)' : undefined,
        }}
      />

      {/* Collection Image */}
      <div className="shrink-0 w-10 h-10 rounded-md overflow-hidden bg-muted">
        {collection.image ? (
          <img
            src={collection.image}
            alt={collection.title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Package className="h-4 w-4 text-muted-foreground" />
          </div>
        )}
      </div>

      {/* Collection Info */}
      <div className="flex-1 min-w-0">
        <p className="font-medium text-sm text-foreground truncate">
          {collection.title}
        </p>
      </div>
    </div>
  );
};

export default CollectionCard;
